import axios from "axios"
import API_URLS from "../../config/global_variables";
const userData = localStorage.userData?JSON.parse(localStorage.userData):"";

const apidata = async () => {
  try {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: API_URLS.GET_LOGS,
      headers: {
        'Content-Type': 'application/json','Authorization': userData.token
      },
    };

    let response = await axios.request(config);

    if (response.status === 200 && Array.isArray(response.data?.data)) {
      const mappedData = response.data.data.map((item, index) => {
        return {
          key: item.id || index, 
          api_name: item.api_name,
          message: item.message,
          source: item.source,
          user_id: item.user_id,
          request_body: item.request_body,
          created_at: new Date(item.created_at).toLocaleString("en-GB"),
        };
      });     
      return mappedData;
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return [];
  }
};

const apiHelpers = {
  apidata
};

export default apiHelpers;